/* Dải cam kết — chạy chữ khi không đủ chỗ hiện hết trên một dòng.

   Chỉ bật khi ĐO ĐƯỢC là thiếu chỗ, không bật theo bề rộng màn hình: nội dung
   do người quản trị nhập trong theme editor, dài ngắn tuỳ lúc. Máy tính rộng
   thường vẫn đủ chỗ nên dải đứng yên, căn giữa như cũ.

   Nội dung được nhân đôi để nối vòng không lộ khoảng trắng. Bản sao gắn
   aria-hidden để trình đọc màn hình không đọc lặp hai lần. */
(function () {
  'use strict';

  var SPEED = 55; // px mỗi giây — đủ chậm để đọc kịp khi lướt qua

  function setup(bar) {
    var box = bar.querySelector('.egr-commit__in');
    var track = bar.querySelector('.egr-commit__track');
    var seq = track && track.querySelector('.egr-commit__seq');
    if (!box || !track || !seq) return;

    // Dọn trạng thái cũ trước khi đo lại (đổi hướng máy, editor dựng lại section)
    bar.classList.remove('is-run');
    var clone = track.querySelector('.egr-commit__seq[aria-hidden]');
    if (clone) clone.remove();

    // 2px đệm: tránh bật/tắt nhấp nháy do làm tròn subpixel
    if (seq.scrollWidth <= box.clientWidth + 2) return;

    var dup = seq.cloneNode(true);
    dup.setAttribute('aria-hidden', 'true');
    track.appendChild(dup);
    bar.classList.add('is-run');

    // Một vòng = đi hết bề ngang của MỘT bản (đã gồm khoảng cách nối)
    var dur = Math.max(12, Math.round(seq.getBoundingClientRect().width / SPEED));
    bar.style.setProperty('--egr-commit-dur', dur + 's');
  }

  function init() {
    document.querySelectorAll('.egr-commit').forEach(setup);
  }

  var timer;
  function reflow() {
    clearTimeout(timer);
    timer = setTimeout(init, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Font Be Vietnam Pro nạp sau có thể đổi bề rộng chữ -> đo lại
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);
  window.addEventListener('resize', reflow);
  document.addEventListener('shopify:section:load', init);
})();
